import React from 'react';
import { ieCheck } from '../../../helpers/utils';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import _filter from 'lodash/filter';

const BundleCard = (props) => {


  let imageObj = {
    imageQuality:60,
    src:""
  }

  try{
    imageObj.src = _filter(props.cyoaProducts, ['name', props.data.name])[0].media === undefined ? "" : _filter(_filter(props.cyoaProducts, ['name', props.data.name])[0].media, ['title', 'hero'])[0].url
  }
  catch(e){}

  const standardImg = () => {
    return (
      <img
        className="lazyload original"
        alt=""
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        data-sizes="auto"
        data-srcset={`https:${imageObj.src}?w=150&q=${imageObj.imageQuality} 1x,
        https:${imageObj.src}?w=300&q=${imageObj.imageQuality} 2x`} />
    )
  }

  const ieImg = () => {
    return (
      <img
        alt=""
        src={`https:${imageObj.src}?w=150&q=${imageObj.imageQuality}`} />
    )
  }

  const priceWithDiscount = (price, percentage) => {
    const discountPrice = price / 100 * percentage;
    const totalPrice = price - discountPrice
    return totalPrice.toFixed(2);
  }

  const totalDiscount = () => {

    const upgradeDiscount = props.data.price_integer / 100 * props.data.discount_percentage;
    const tripDiscount = props.bookingGroupTrips[0].passengers[0].price / 100 * 10;
    const totalDiscount = upgradeDiscount + tripDiscount;
    return totalDiscount.toFixed(2);

  }
  

  return (
    <div className="bundle-card">
      <div className="row">
        <div className="column small-12 medium-12 large-4 hide-for-small-only hide-for-medium-only no-margin no-padding-right">

          { ieCheck() ? ieImg() : standardImg() }

        </div>
        <div className="column small-12 medium-12 large-8 no-margin">

          <div className="bundle-card-description">
            <h5 className="busabout-h5 small">{props.data.name} ({props.data.duration} days)</h5>
          </div>


          <div className="bundle-card-text">
              <div className="row">
                <div className="column small-12">
                  <p className="no-margin">
                   <del>{props.data.price}</del> 
                  <span className="orange-text bold"> {ISOCurrencyCovert(props.data.currency)}{priceWithDiscount(props.data.price_integer, props.data.discount_percentage)}</span>
                  </p>
                  <p className="no-margin">
                    total saving <span className="bold">{ISOCurrencyCovert(props.data.currency)}{totalDiscount()}</span>
                  </p>
                </div>
                <div className="column small-12">
                  <div className="add-button" onClick={ () => props.onAddBundle(props.index) }>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z"/>
                    </svg>
                    Add
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
    </div>
  )
}

export default BundleCard;



// WEBPACK FOOTER //
// ./src/components/shared/bundles/bundle-card.js